import { analyticsReady } from '../Firebase';
import { logEvent } from 'firebase/analytics';

// Analytics 초기화 전에 호출돼도 버리지 않고, 초기화가 끝나면 호출 순서대로 보낸다.
export const trackEvent = (eventName, eventParams = {}) => {
  analyticsReady.then(analytics => {
    if (analytics) {
      logEvent(analytics, eventName, eventParams);
    }
  });
};

// 자주 사용하는 이벤트 추적 함수들
export const trackPageView = (pageTitle) => {
  trackEvent('page_view', {
    page_title: pageTitle,
    page_location: window.location.href,
    page_path: window.location.pathname
  });
};

export const trackButtonClick = (buttonName, buttonLocation) => {
  trackEvent('button_click', {
    button_name: buttonName,
    button_location: buttonLocation
  });
};

export const trackDownload = (fileName) => {
  trackEvent('file_download', {
    file_name: fileName
  });
};

// Meta Pixel (public/index.html 의 <head> 에서 초기화됨)
// SPA 라우팅은 페이지가 새로 로드되지 않으므로 경로 이동 시 수동으로 PageView 를 보낸다.
export const trackPixelPageView = () => {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', 'PageView');
  }
};

export const trackPixelEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', eventName, eventParams);
  }
};
